export type MaybeArray<T> = T | T[]

export function asArray<T>(input: MaybeArray<T>): T[] {
  if (Array.isArray(input)) {
    return input
  }
  return [input]
}
